import { Pipe, PipeTransform } from '@angular/core';

/**
 * Determins if a property can be edited when the table is editable.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'uneditable',
})
export class UneditablePipe implements PipeTransform {
  /**
   * @param editable Whether the table is editable
   * @param prop the property to check if it can be edited
   * @param disabledCols Array of column ids that should remain uneditable
   * @returns whether the given property can be edited while the table is editable
   */
  transform(editable: boolean, prop: string, disabledCols: string[] | null | undefined): boolean {
    return !editable || prop === 'dataType' || !!disabledCols?.some((c) => c.toLowerCase() === prop.toLowerCase());
  }
}
